export default function getFullName(firstName: string, lastName: string) {
  return `${firstName} ${lastName}`;
}
